export default __webpack_public_path__ + "static/media/find.ab5b7b30.svg";